var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranchiseInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_4710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 10.6875C13.3974 10.6875 13.1875 10.4776 13.1875 10.2188V7.5H11.125C10.8661 7.5 10.6562 7.29013 10.6562 7.03125C10.6562 6.77237 10.8661 6.5625 11.125 6.5625H13.6562C13.9151 6.5625 14.125 6.77237 14.125 7.03125V10.2188C14.125 10.4776 13.9151 10.6875 13.6562 10.6875Z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6875C7.74112 10.6875 7.53125 10.4776 7.53125 10.2188V7.96875C7.53125 7.70987 7.74112 7.5 8 7.5C8.25888 7.5 8.46875 7.70987 8.46875 7.96875V10.2188C8.46875 10.4776 8.25888 10.6875 8 10.6875Z",
    fill: "#6B66D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 10.2188V7.96875C8.46875 7.70987 8.25888 7.5 8 7.5V10.6875C8.25888 10.6875 8.46875 10.4776 8.46875 10.2188Z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 12.0937C10.3438 10.8014 9.29234 9.75 8 9.75C6.70766 9.75 5.65625 10.8014 5.65625 12.0937C5.65625 12.9961 6.18281 13.8187 6.98703 14.2052L7.56256 15.6997C7.71675 16.1001 8.28325 16.1001 8.43744 15.6997L9.01297 14.2052C9.81719 13.8187 10.3438 12.9961 10.3438 12.0937Z",
    fill: "#FF936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43744 15.6997L9.01297 14.2052C9.81719 13.8187 10.3438 12.9961 10.3438 12.0938C10.3438 10.8014 9.29234 9.75 8 9.75V16C8.18016 16 8.36034 15.8999 8.43744 15.6997Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.875C8.43147 12.875 8.78125 12.5252 8.78125 12.0938C8.78125 11.6623 8.43147 11.3125 8 11.3125C7.56853 11.3125 7.21875 11.6623 7.21875 12.0938C7.21875 12.5252 7.56853 12.875 8 12.875Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 12.0938C8.78125 11.6623 8.43147 11.3125 8 11.3125V12.875C8.43147 12.875 8.78125 12.5252 8.78125 12.0938Z",
    fill: "#E2E2EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 10.6875C2.08487 10.6875 1.875 10.4776 1.875 10.2188V7.03125C1.875 6.77237 2.08487 6.5625 2.34375 6.5625H4.875C5.13387 6.5625 5.34375 6.77237 5.34375 7.03125C5.34375 7.29013 5.13387 7.5 4.875 7.5H2.8125V10.2188C2.8125 10.4776 2.60263 10.6875 2.34375 10.6875Z",
    fill: "#6B66D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40625 2.75V7.96875C4.40625 8.22762 4.61612 8.4375 4.875 8.4375H6.90625L8 7.8125L9.09375 8.4375H11.125C11.3839 8.4375 11.5938 8.22762 11.5938 7.96875V2.75H4.40625Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75V7.8125L9.09375 8.4375H11.125C11.3839 8.4375 11.5938 8.22762 11.5938 7.96875V2.75H8Z",
    fill: "#FFC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 8.4375H6.90625V6.40625C6.90625 6.14737 7.11612 5.9375 7.375 5.9375H8.625C8.88388 5.9375 9.09375 6.14737 9.09375 6.40625V8.4375Z",
    fill: "#B5BAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09375 6.40625C9.09375 6.14737 8.88388 5.9375 8.625 5.9375H8V8.4375H9.09375V6.40625Z",
    fill: "#7984EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.71875L3.78125 2.34375V3.16406C3.78125 3.74656 4.25344 4.21875 4.83594 4.21875C5.41844 4.21875 5.89062 3.74656 5.89062 3.16406C5.89062 3.74656 6.36281 4.21875 6.94531 4.21875C7.52781 4.21875 8 3.74656 8 3.16406C8 3.74656 8.47219 4.21875 9.05469 4.21875C9.63719 4.21875 10.1094 3.74656 10.1094 3.16406C10.1094 3.74656 10.5816 4.21875 11.1641 4.21875C11.7466 4.21875 12.2188 3.74656 12.2188 3.16406V2.34375L8 1.71875Z",
    fill: "#FF936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.71875V3.16406C8 3.74656 8.47219 4.21875 9.05469 4.21875C9.63719 4.21875 10.1094 3.74656 10.1094 3.16406C10.1094 3.74656 10.5816 4.21875 11.1641 4.21875C11.7466 4.21875 12.2188 3.74656 12.2188 3.16406V2.34375L8 1.71875Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.14 2.08375L10.89 0.20875C10.8031 0.0783437 10.6567 0 10.5 0H5.5C5.34328 0 5.19691 0.0783437 5.10997 0.208719L3.85997 2.08372C3.80866 2.16075 3.78125 2.25122 3.78125 2.34375H12.2188C12.2188 2.25122 12.1914 2.16075 12.14 2.08375Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.14 2.08375L10.89 0.20875C10.8031 0.0783437 10.6567 0 10.5 0H8V2.34375H12.2188C12.2188 2.25122 12.1914 2.16075 12.14 2.08375Z",
    fill: "#FF1F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 12.0937C4.6875 10.8014 3.63609 9.75 2.34375 9.75C1.05141 9.75 0 10.8014 0 12.0937C0 12.9961 0.526562 13.8187 1.33078 14.2052L1.90631 15.6997C2.0605 16.1001 2.627 16.1001 2.78119 15.6997L3.35672 14.2052C4.16094 13.8187 4.6875 12.996 4.6875 12.0937Z",
    fill: "#FF936B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 12.875C2.77522 12.875 3.125 12.5252 3.125 12.0938C3.125 11.6623 2.77522 11.3125 2.34375 11.3125C1.91228 11.3125 1.5625 11.6623 1.5625 12.0938C1.5625 12.5252 1.91228 12.875 2.34375 12.875Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.0937C16 10.8014 14.9486 9.75 13.6562 9.75C12.3639 9.75 11.3125 10.8014 11.3125 12.0937C11.3125 12.9961 11.8391 13.8187 12.6433 14.2052L13.2188 15.6997C13.373 16.1001 13.9395 16.1001 14.0937 15.6997L14.6692 14.2052C15.4734 13.8187 16 12.996 16 12.0937Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 12.875C14.0877 12.875 14.4375 12.5252 14.4375 12.0938C14.4375 11.6623 14.0877 11.3125 13.6562 11.3125C13.2248 11.3125 12.875 11.6623 12.875 12.0938C12.875 12.5252 13.2248 12.875 13.6562 12.875Z",
    fill: "#E2E2EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_4710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranchiseInsights);
export default __webpack_public_path__ + "static/media/FranchiseInsights.beeef420b9e29abdad45270d900ca718.svg";
export { ForwardRef as ReactComponent };